import React from "react";
import { MapsWidget } from "../../components/Widgets/MapsWidget";
import { MultipleWidgetsWrapper } from "../../components/Widgets/MultipleWidgetsWrapper";
import { OperationStatusWidget } from "../../components/Widgets/OperationStatusWidget";
import { SatisfactionWidget } from "../../components/Widgets/SatisfactionWidget";
import { SemiCircleWidget } from "../../components/Widgets/SemiCircleWidget";
import { SlaMatchingWidget } from "../../components/Widgets/SlaMatchingWidget";
import { TwoDaysConsumeAreaChartWidget } from "../../components/Widgets/TwoDaysConsumeAreaChartWidget";
import { WeatherWidget } from "../../components/Widgets/WeatherWidget";
import { StreetBarChartWidget } from "../../components/Widgets/StreetBarChartWidget";
import { TableIncidentsWidget } from "../../components/Widgets/TableIncidentsWidget";
import { MapOverlay } from "../../components/VideoWall/Layouts/MapOverlay";

const Components = {
    weather: WeatherWidget,
    satisfaction: SatisfactionWidget,
    slamatching: SlaMatchingWidget,
    semicircle: SemiCircleWidget,
    multiplewrapper: MultipleWidgetsWrapper,
    maps: MapOverlay,//MapsWidget
    operationstatus: OperationStatusWidget,
    twoDaysConsumeAreaChartWidget: TwoDaysConsumeAreaChartWidget,
    streetBarChartWidget: StreetBarChartWidget,
    tableIncidentsWidget: TableIncidentsWidget
}

export default block => {
    // component does exist
    if (typeof Components[block.component] !== "undefined") {
        try{
            return React.createElement(Components[block.component], {
                key: block.id,
                block: block
            });
        } catch(err){
            return err.message;
        }
    }
    // component doesn't exist yet
    return React.createElement(
        () => <div>The component {block.component} has not been created yet.</div>,
        { key: block.id }
    );
}